Wee.fn.make('funding', {
	init: function() {
		var priv = this.$private;

		priv.fundingLocationListener();
		priv.toggleResultsEvent();
		priv.toggleSearchForm();
		priv.scrollToTop($('ref:backToTop'));
		priv.getLocationOptions($('ref:fundingCountry'));

		$('ref:select').on('change', function(e, el) {
			$(el).addClass('-selected');
		});
	},
	unload: function() {
		$.events.off(null, '.funding');
		$.screen.reset('toggleDisabled');
	}
}, {
	/**
	 * Scroll to the top
	 *
	 * @param {object}
	 */
	scrollToTop: function($el) {
		$el.on('click.funding', function() {
			$._body.scrollTop = 0;
		});
	},
	fundingLocationListener: function() {
		var scope = this,
			$country = $('ref:fundingCountry');

		if (! Object.keys($.routes.uri().query).length) {
			$country.val('');
			$('ref:fundingState').val('');
			$('ref:fundingProject').val('');
			$country.trigger('change');
		}

		$country.on('change.funding', function(e, el) {
			scope.getLocationOptions($(el));
		});
	},

	/**
	 * Get each location's state options
	 *
	 * @param {object}
	 */
	getLocationOptions: function($country) {
		var selected = $country.val(),
			$states,
			$currentStates;

		// If emptyStates is already in form, leave it alone
		if (! selected.length && $('ref:emptyStates', 'ref:fundingForm').length) {
			return;
		}

		$states = $('ref:' + selected);
		$currentStates = $('ref:states', 'ref:fundingForm');

		if ($states.length && $states !== $currentStates) {
			$states.insertAfter($currentStates);

			$currentStates.appendTo('ref:regionSelects');
		} else {
			$('ref:fundingCountryContainer').insertAfter('ref:emptyStates');

			$currentStates.appendTo('ref:regionSelects');
		}
	},
	toggleResultsEvent: function() {
		var scope = this,
		 	$toggle = $('ref:fundingToggle');

		$toggle.on({
			click: function(e, el) {
				scope.toggleResults(el);
			},
			keydown: function(e, el) {
				if (e.keyCode == 13) {
					scope.toggleResults(el);
				}
			}
		}, {
			namespace: 'funding'
		});
	},
	toggleResults: function(el) {
		var $el = $(el),
			$detail = $el.siblings('ref:fundingDetail'),
			$title = $el.siblings('ref:fundingTitle');

			$detail.toggle();
			$el.toggleClass('-hide-icon');

			if (! $detail.hasClass('js-hide')) {
				$title.hide();
				$el.attr({
					'aria-selected': 'true',
					'aria-expanded': 'true'
				});
				$detail.attr('aria-hidden', 'false');
			} else {
				$title.show();
				$el.attr({
					'aria-selected': 'false',
					'aria-expanded': 'false'
				});
				$detail.attr('aria-hidden', 'true');
			}
	},
	toggleSearchForm: function() {
		var $toggle = $('ref:fundingSearchToggle'),
			$actionLinks = $('ref:fundingActions'),
			disabledClass = 'button-disabled';

		$.screen.map([
			{
				min: 3,
				namespace: 'toggleDisabled',
				callback: function() {
					$actionLinks.removeClass(disabledClass);
				}
			},
			{
				max: 2,
				namespace: 'toggleDisabled',
				callback: function() {
					if (! $('ref:fundingFormWrapper').hasClass('js-hide')) {
						$actionLinks.addClass(disabledClass);
					}
				}
			}
		]);

		$toggle.on('click.funding', function(e, el) {
			$('ref:fundingFormWrapper').toggle();
			$(el).toggleClass('-close');
			$actionLinks.toggleClass(disabledClass);

		});
	}
});